import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { FormHelperText } from '@mui/material'
import CustomInput from './styled/CustomInput.styled'
import { Container } from 'react-bootstrap'
import '../styles/Modal.scss'
import ResetPasswordImage from '../assets/imgs/reset-password-placeholder-image.svg'
import { saveOrUpdateDataById } from '../apis/generalApis'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#08C4BB',
    },
  },
  typography: {
    fontFamily: [
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background:
            'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 44%, #2992FB 100%) 0% 0% no-repeat padding-box',
          borderRadius: '10px',
          opacity: 1,
          height: '37px',
          color: '#fff',
          textTransform: 'capitalize',
        },
        '&:hover': {
          // backgroundColor: '#000'
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'primary',
          borderRadius: '16px',
          '&.Mui-checked': {
            color: '#2597F6',
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          border: '1px solid #fff',
          borderRadius: '16px',
          boxShadow: '0px 5px 20px #00000040',
          backdropFilter: 'blur(10px)',
        },
      },
    },
  },
})

const ResetPasswordModal = ({
  handleResetPasswordModal,
  modalOpen = false,
}) => {
  const [email, setEmail] = React.useState('')

  const handleResetPassword = async (e) => {
    e.preventDefault()
    if (!email) return
    let body = {
      email,
    }
    let result = await saveOrUpdateDataById(
      'password-reset',
      JSON.stringify(body),
    )
    // if(result?.success === true)
  }

  return (
    <ThemeProvider theme={theme}>
      {/* <div> */}
      <>
        <Modal
          open={modalOpen}
          onClose={() => handleResetPasswordModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <form onSubmit={handleResetPassword}>
              <Container>
                <img
                  src={ResetPasswordImage}
                  alt="Reset Password"
                  height={132}
                />
                <h3 className="my-3 fs-18 fw-bold" id="reset-password-heading">
                  Reset Password
                </h3>
                <p className="fs-18 my-4">
                  Enter your email and we will send a link to <br /> you where
                  you can reset your password
                </p>
                <FormHelperText id="input-label" margin="dense">
                  Email
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  id="email"
                  placeholder="janedoe@mail.com"
                  fullWidth={true}
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="mb-3"
                  required
                />
                <Button
                  disableElevation
                  variant="contained"
                  fullWidth={true}
                  type="submit"
                >
                  Reset Password
                </Button>
              </Container>
            </form>
          </Box>
        </Modal>
      </>
      {/* </div> */}
    </ThemeProvider>
  )
}

export default ResetPasswordModal
